// Everything in this file must be imported or prefixed with window
// to avoid "Uncaught ReferenceError: <variable> is not defined"

const $ = window.$;
const _ = window._;
const Backbone = window.Backbone;
const numeral = window.numeral;
const tinycolor = window.tinycolor;
const WordCloud = window.WordCloud;
const PptxGenJS = window.PptxGenJS;
const opentype = window.opentype;
const JSZip = window.JSZip;

export {
    $,
    _,
    Backbone,
    numeral,
    tinycolor,
    WordCloud,
    PptxGenJS,
    opentype,
    JSZip
};
